var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m90 310.924v-207.848c-50.816 7.301-90 51.12-90 103.924s39.184 96.623 90 103.924z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m317 50h5v5c0 8.284 6.716 15 15 15s15-6.716 15-15v-5h5c8.284 0 15-6.716 15-15s-6.716-15-15-15h-5v-5c0-8.284-6.716-15-15-15s-15 6.716-15 15v5h-5c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m457 50h5v5c0 8.284 6.716 15 15 15s15-6.716 15-15v-5h5c8.284 0 15-6.716 15-15s-6.716-15-15-15h-5v-5c0-8.284-6.716-15-15-15s-15 6.716-15 15v5h-5c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m55 372h-5v-5c0-8.284-6.716-15-15-15s-15 6.716-15 15v5h-5c-8.284 0-15 6.716-15 15s6.716 15 15 15h5v5c0 8.284 6.716 15 15 15s15-6.716 15-15v-5h5c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m367 342c8.271 0 15-6.729 15-15v-15h-30v15c0 8.271 6.729 15 15 15z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m412 327c0 24.813-20.187 45-45 45s-45-20.187-45-45v-15h-70v110h260v-110h-100z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m90 312h132v110h-132z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m406.426 219.426c-29.353-17.942-63.734-27.426-99.426-27.426s-70.073 9.484-99.426 27.426c-25.966 15.873-46.489 37.38-59.885 62.574h318.621c-13.395-25.194-33.918-46.701-59.884-62.574z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m252 512h245c8.284 0 15-6.716 15-15v-45h-260z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m90 497c0 8.284 6.716 15 15 15h117v-60h-132z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m191.928 193.83c32.044-19.587 69.154-30.486 107.75-31.711 8.414-23.792 23.316-44.545 42.574-60.119h-222.252v168.494c.362-.872.752-1.735 1.201-2.578 15.899-29.903 40.356-55.521 70.727-74.086z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m331.528 163.319c32.377 3.484 63.293 13.852 90.544 30.51 6.97 4.261 13.612 8.91 19.928 13.88v-90.709c0-8.284-6.716-15-15-15-42.319 0-78.866 25.168-95.472 61.319z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChest);
export default __webpack_public_path__ + "static/media/chest.f930d286d6ba4951200317c915fcb019.svg";
export { ForwardRef as ReactComponent };